export default "__VITE_ASSET__bba7ca33__"